//
//  format.tsx
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: September 23, 2026
//  Author: Bob Keathley
//
//  Shared render helpers for the console pages: relative time, the est. spend
//  display and the live dot with sync lag. Kept apart so pages never import
//  one another just for formatting.
//
// Shared render helpers used across Fleet/Runs/Run/Workstreams/Machines -- kept out of any single
// page module so none of them need to import another page module just for formatting.

export const ago = (s: number | null | undefined) => {
  if (!s) return '—'
  const d = Math.max(0, Date.now() / 1000 - s)
  return d < 60 ? `${Math.round(d)}s ago` : d < 3600 ? `${Math.round(d / 60)}m ago` : d < 86400 ? `${Math.round(d / 3600)}h ago` : `${Math.round(d / 86400)}d ago`
}

/** Every spend figure is a transcript-derived estimate, never a billed number -- always "est." with
 * this tooltip. `signet calibrate` is what anchors it to an invoice; nothing here claims to be one. */
export const CALIBRATE_TITLE = 'transcript-derived estimate; signet calibrate anchors it to an invoice'
export function EstSpend({ usd }: { usd: number | null | undefined }) {
  if (usd === null || usd === undefined) return <span className="hint">—</span>
  return <span title={CALIBRATE_TITLE}>est. ${usd.toFixed(2)}</span>
}

/** `lagS` is `server_time - last_at` (§6e) -- how far behind the acting tenant's `syncd` is, in
 * whole seconds, so a stalled daemon reads as a growing number next to the dot instead of silence.
 * `null` (no `server_time` reference yet, or none available for this route) renders no readout. */
export function LiveDot({ live, lagS, lagTitle }: { live: boolean; lagS?: number | null; lagTitle?: string }) {
  const title = lagS !== null && lagS !== undefined ? (lagTitle ?? `sync lag ${lagS}s`) : live ? 'live' : 'not live'
  return (
    <>
      <span className={`live-dot ${live ? 'on' : ''}`} title={title} aria-label={live ? 'live' : 'not live'} />
      {lagS !== null && lagS !== undefined && <span className="hint mono" title={title}> {lagS}s lag</span>}
    </>
  )
}
